import { combineReducers } from "redux";
import * as types from "./types";
import { USER_SIGNED_OUT } from "../user/types";

const ancillariesSummaryReducer = (
  state = {
    isFetching: false,
    isLoaded: false
  },
  action
) => {
  switch (action.type) {
    case types.FETCH_ANCILLARY_SUMMARY_REQUEST:
      return { ...state, isFetching: true };
    case types.FETCH_ANCILLARY_SUMMARY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isLoaded: true,
        ...action.data.entities.ancillaries
      };
    case USER_SIGNED_OUT:
      return {
        isFetching: false,
        isLoaded: false
      };
    default:
      return state;
  }
};

const ancillariesByVbidReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_ANCILLARIES_REQUEST:
      return { ...state, [action.isbn]: { isFetching: true } };
    case types.FETCH_ANCILLARIES_SUCCESS:
      return {
        ...state,
        [action.isbn]: {
          title: action.data.title,
          ancillaries: action.data.ancillaries,
          isFetching: false
        }
      };
    case types.FETCH_ANCILLARIES_FAILURE:
      return {
        ...state,
        [action.isbn]: {
          title: "error",
          ancillaries: [],
          isFetching: false
        }
      };
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const accessCodesReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_ALL_ACCESS_CODE_REQUEST:
      return { ...state, isFetching: true };
    case types.FETCH_ALL_ACCESS_CODE_SUCCESS:
      const data = action.data.licenses.reduce((acc, book) => {
        return {
          ...acc,
          [book.isbn]: book.ancillaries[book.ancillaries.length - 1],
          isFetching: false
        };
      }, {});
      return { ...state, isFetching: false, ...data };
    case types.FETCH_ALL_ACCESS_CODE_FAILURE:
      return { ...state, isFetching: false };
    case types.REDEEM_ANCILLARY_REQUEST:
      const requestObj = state[action.isbn] || {};
      return {
        ...state,
        [action.isbn]: { ...requestObj, isRedeeming: true }
      };
    case types.REDEEM_ANCILLARY_SUCCESS:
      const successObj = action.data;
      return {
        ...state,
        [action.isbn]: {
          ...state[action.isbn],
          ...successObj,
          isRedeeming: false
        }
      };
    case types.REDEEM_ANCILLARY_FAILURE:
      const failureObj = action.data;
      return {
        ...state,
        [action.isbn]: {
          ...state[action.isbn],
          ...failureObj,
          isRedeeming: false
        }
      };
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const ancillariesReducer = combineReducers({
  summary: ancillariesSummaryReducer,
  byVbid: ancillariesByVbidReducer,
  accessCodes: accessCodesReducer
});

export default ancillariesReducer;
